import { Suspense, lazy } from 'react';

const TargetsSurvey = lazy(() => import('../components/TargetsSurvey'));

const TargetsSurveyLazy: React.FC = () => {
    return <Suspense><TargetsSurvey/></Suspense>;
}

export default TargetsSurveyLazy;